import { DEFAULT_MAX_MONTHS, DEFAULT_MIN_MONTHS } from './calculatorConstants.js';
export const getMoneyDefaultValue = (defaultParams, defaultMoney = 0) => defaultParams?.sum ? defaultParams.sum : defaultMoney;
export const getMonthsDefaultValue = (defaultParams, defaultMonth = 0) => defaultParams?.period &&
    defaultParams.period >= DEFAULT_MIN_MONTHS &&
    defaultParams.period <= DEFAULT_MAX_MONTHS
    ? defaultParams.period
    : defaultMonth;
//# sourceMappingURL=getDefaultValues.js.map